import { ArrowUpRight, MapPin, Phone } from "lucide-react";
import { imgSet, imgUrl, useContent } from "@/lib/content";
import { Reveal } from "./Reveal";

export const Visit = () => {
  const { visit: v, newsletter: n, contact } = useContent().data;
  const [first, ...rest] = v.address_lines.split("\n");
  return (
    <>
      <section className="section" id="visit" data-testid="visit-section">
        <div className="wrap visit">
          <Reveal>
            <p className="eyebrow">{v.eyebrow}</p>
            <h2>{v.title}</h2>
            <p data-testid="visit-address"><strong>{first}</strong>{rest.map((l) => <span key={l}><br />{l}</span>)}</p>
            <p data-testid="visit-hours"><strong>Opening hours</strong><br />{v.hours}</p>
            <p>{v.note}</p>
            <div className="contact-links">
              <a className="btn pink" href={contact.maps_url} target="_blank" rel="noopener noreferrer" data-testid="visit-directions-button"><MapPin size={15} /> Get directions</a>
              <a className="btn light" href={`tel:${contact.phone_call}`} data-testid="visit-call-button"><Phone size={15} /> Call the spa</a>
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <img className="visit-image" loading="lazy" src={imgUrl(v.image, 800)} srcSet={imgSet(v.image)} sizes="(min-width: 850px) 50vw, 100vw" alt="Spa interior" />
          </Reveal>
        </div>
      </section>
      <section className="newsletter" data-testid="newsletter-section">
        <img className="news-logo" src="/brand/logo-gold.png" alt="Wax Moi" width="835" height="240" loading="lazy" />
        <p className="eyebrow">{n.eyebrow}</p>
        <h2>{n.title}</h2>
        <p>{n.text}</p>
        {n.link_url && (
          <a className="btn pink" href={n.link_url} target="_blank" rel="noopener noreferrer" data-testid="original-website-link">
            {n.link_label} <ArrowUpRight size={14} />
          </a>
        )}
      </section>
    </>
  );
};
